import { memo } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { defaultMentalStateData } from '../../../utils/helpers';
import NoteDropdown from '../partials/noteDropdown';

const fields = [
  { key: 'appearanceAndBehavior', label: 'Appearance and Behavior' },
  { key: 'speech', label: 'Speech' },
  { key: 'moodAndAffect', label: 'Mood and Affect' },
  { key: 'perception', label: 'Perception' },
  { key: 'thoughtProcess', label: 'Thought Process' },
  { key: 'thoughtContent', label: 'Thought Content' },
  { key: 'insight', label: 'Insight' },
  { key: 'judgment', label: 'Judgment' },
  { key: 'cognition', label: 'Cognition' },
];

const MentalStateExamination = ({
    selectedOnExamination,
    handleOnExaminationData,
}) => {
    let { mentalStateExamination } = selectedOnExamination;
    mentalStateExamination = mentalStateExamination || defaultMentalStateData();

    const allNotes = useSelector((state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || []);

    const handleMentalStateExamination = (field, value) => {
        const updatedData = { ...mentalStateExamination };
        updatedData[field] = value;
        handleOnExaminationData(updatedData, 'mentalStateExamination');
    };

    return (
        <div className="general-examination">
            {fields.map(({ key, label }) => (
                <Form.Group as={Row} className="mb-3" key={key}>
                    <Col sm="3">
                        <Form.Label column className="font-weight-bold">
                            {label}:
                        </Form.Label>
                    </Col>
                    <Col sm="9">
                        <NoteDropdown
                            value={mentalStateExamination[key] || ''}
                            onChange={(val) => handleMentalStateExamination(key, val)}
                            placeholder="Note"
                            suggestions={allNotes.filter(
                                (n) => n.elementType === 'mentalStateExamination' && n.itemElement === key,
                            )}
                        />
                    </Col>
                </Form.Group>
            ))}
        </div>
    );
};

export default memo(MentalStateExamination);
